module.exports = __webpack_public_path__ + "static/media/C8.f1f52edf.jpg";